module.exports = __webpack_public_path__ + "static/media/13_insideyourblood.3fcc5c4b.jpg";